import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {bindQueryParam} from "../../../AppLocals/functions/routerHelper";
import {image_directDestroy_Api, image_directDestroyMulti_Api, image_directUpload_Api} from "../../../../apis";
import {NotificationActionTypes, successNotify} from "../../../AppLocals/factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {notifyOnError} from "../../../AppLocals/factory/createErrorEvent";


export const useImageActions = ({
                                    owner_type, owner_id,
                                    notifyListeners = {
                                        onCreated: undefined,
                                        onDeleted: undefined,
                                    },
                                }) => {
    const [action, setAction] = useState({type: undefined, value: undefined})
    const t = useTranslate()
    const {
        onCreated = NullAsDefault,
        onDeleted = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)
    const onCancel = () => {
        setAction({})
    }

    const {handleAsyncAction: onDirectUpload, ...asyncDirectUploading} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: image_directUpload_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: onDirectDelete, ...asyncDirectDeleting} = useAsyncAction({
        onError,
        apiInfo: image_directDestroy_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })

    const {handleAsyncAction: onMultiDirectDelete, ...asyncMultiDirectDeleting} = useAsyncAction({
        onError,
        apiInfo: image_directDestroyMulti_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })


    return {
        onDirectUpload, asyncDirectUploading,
        onDirectDelete, asyncDirectDeleting,
        onMultiDirectDelete, asyncMultiDirectDeleting,
    }
}



